import '../../../../../vendor/assets/javascripts/inline-attachment/inline-attachment';
import '../../../../../vendor/assets/javascripts/inline-attachment/jquery.inline-attachment';
import '../../../../../vendor/assets/javascripts/sticky-sidebar/ResizeSensor.cjs';
import '../../../../../vendor/assets/javascripts/sticky-sidebar/sticky-sidebar.cjs';
import '../../../../../vendor/assets/javascripts/jquery.lazyload';
import '../../../../../vendor/assets/javascripts/jquery.numberedtextarea';
import '../../../../../vendor/assets/javascripts/overlapping_marker_spiderfier.mjs';
import '../../../../../vendor/assets/javascripts/yubinbango';
